import {useMemo} from "react";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import ReactHtmlParser from "react-html-parser";
import {useTranslation} from "react-i18next";
import {BllinkLogger} from "../../../common/utils/bllink_loggers";
import MonthTableLogic from "../table/monthTableLogic";
import {constants} from "../../../common/constants/constants";

import TenantRecord from "../../../images/tenant_claim_paid.svg";
import FullPaid from "../../../images/full_paid.svg";
import HalfPaid from "../../../images/half_checked.svg";
import ScheduledToPay from "../../../images/managers/scheduled_to_pay.png";


function oneTimeIconData(oneTimeData, t) {

    let alt, src, toolTipText = '', excelText = '', renderEmpty = false;

    const totalFormatted = oneTimeData.total.isPercent ? `${oneTimeData.total.value}%` : oneTimeData.total.value;
    const paidFormatted = oneTimeData.paid.isPercent ? `${oneTimeData.paid.value}%` : oneTimeData.paid.value;

    let label = totalFormatted;

    // https://app.asana.com/0/1200855539606174/1200898364967670
    // Changed to similar logic as for monthly data
    const fullOrOverPaid = oneTimeData.total.value <= oneTimeData.paid.value;
    const didntPay = oneTimeData.paid.value === 0 && oneTimeData.scheduled_to_pay.value === 0;
    const partlyPaid = oneTimeData.paid.value < oneTimeData.total.value && oneTimeData.paid.value > 0;
    const scheduledToPay = oneTimeData.scheduled_to_pay.value > 0;
    const isTenantRecord = oneTimeData.payment_methods?.includes(constants.managerPaymentsOptions.tenantRecordKey)
        && oneTimeData?.is_tenant_record_not_approved;

    //https://app.asana.com/0/1196545425570329/1199534726301541
    // add currency to excel sheets
    // const currency = t('currency.' + oneTimeData.total.currency.toLowerCase());

    if (isTenantRecord) {
        alt = 'Marked as paid';
        src = TenantRecord;
        label = paidFormatted;
        toolTipText = t('reports.tenant_claim_paid_explanation', {paid: paidFormatted});
        excelText = paidFormatted;
    } else if (fullOrOverPaid) {
        alt = 'Full Paid';
        src = FullPaid;
        label = paidFormatted;
        toolTipText = t('reports.paid_full', {paid: paidFormatted});
        excelText = paidFormatted;
    } else if (didntPay) {
        renderEmpty = true;
    } else if (partlyPaid) {
        alt = 'Half Paid';
        src = HalfPaid;
        toolTipText = t('reports.paid_out_of_total', {paid: paidFormatted, total: totalFormatted});
        excelText = paidFormatted;
    } else if (scheduledToPay) {
        alt = 'Scheduled To Pay';
        src = ScheduledToPay;
        toolTipText += `<br/> ` + t('reports.paid', {paid: paidFormatted});
        toolTipText += `<br/> ` + t('reports.scheduled_to_pay_only', {scheduledToPay: oneTimeData.scheduled_to_pay.value});
    }

    return {
        alt: alt,
        src: src,
        label: label,
        toolTipText: toolTipText,
        excelText: excelText,
        renderEmpty: renderEmpty,
    };
}

export function OneTimeIcon({ oneTimeData }) {
    const { t } = useTranslation();

    if (oneTimeData == null) {
        return <div/>;
    }

    const payment_methods = useMemo(() => ([...(oneTimeData.payment_methods ?? [])]), [oneTimeData]);
    const result = useMemo(() => oneTimeIconData(oneTimeData, t), [oneTimeData]);
    const toolTipText = useMemo(() => MonthTableLogic.addPaymentMethodsTextIfNeeded(result.toolTipText, { payment_methods }), [result, payment_methods]);

    if (result.renderEmpty) {
        return '';
    }

    if (result.src != null) {
        return (
            <OverlayTrigger placement="top" overlay={props => (<Tooltip {...props}>{ReactHtmlParser(toolTipText)}</Tooltip>)}>
                <div exceltext={result.excelText}>
                    <img className="paid-circle center" alt={result.alt} src={result.src}/>
                    <span className="month-label"> {result.label} </span>
                </div>
            </OverlayTrigger>
        );
    }

    BllinkLogger.error(`un handled case for oneTimeData`, oneTimeData);
    throw new Error(`un handled case for month data`);
}
